import BillingStatus from './BillingStatus.component';
import BillingStatusModal from './BillingStatusModal.component';

export default {
	BillingStatus,
	BillingStatusModal,
};
